import { render, staticRenderFns } from "./PurchaseDialog.vue?vue&type=template&id=533a2f28&scoped=true"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDialog.vue?vue&type=style&index=0&id=533a2f28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a2f28",
  null
  
)

export default component.exports